import { render, staticRenderFns } from "./StakeholdersControl.vue?vue&type=template&id=d4d4333a&"
import script from "./StakeholdersControl.vue?vue&type=script&lang=js&"
export * from "./StakeholdersControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports